import { SVGFC } from '@repo/toolkit/types'

const ChartIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 4V18.2222C4 18.6937 4.1873 19.1459 4.5207 19.4793C4.8541 19.8127 5.30628 20 5.77778 20H20"
        stroke={color}
        strokeWidth="1.77778"
        strokeMiterlimit="5.759"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.55566 13.7777L11.1112 10.2221L14.6668 13.7777L20.0001 8.44434"
        stroke={color}
        strokeWidth="1.77778"
        strokeMiterlimit="5.759"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.333 8.44434H19.9997V11.111"
        stroke={color}
        strokeWidth="1.77778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ChartIcon
